import { FC, SVGProps } from 'react';

const PhoneCallIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
    return (
        <svg
            id="callIcon"
            width="24"
            height="24"
            {...props}
            viewBox="0 0 29 29"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10.8371 14.627C11.8095 16.6151 13.4211 18.2194 15.4136 19.1828C15.5594 19.2518 15.7207 19.2818 15.8815 19.2696C16.0424 19.2574 16.1973 19.2036 16.3311 19.1134L19.2649 17.157C19.3947 17.0705 19.544 17.0177 19.6993 17.0034C19.8546 16.9891 20.011 17.0138 20.1543 17.0753L25.643 19.4276C25.8295 19.5068 25.9852 19.6444 26.0866 19.8198C26.188 19.9952 26.2297 20.1987 26.2054 20.3999C26.0319 21.7574 25.3695 23.0051 24.3423 23.9094C23.3151 24.8137 21.9935 25.3126 20.625 25.3127C16.3981 25.3127 12.3443 23.6336 9.35549 20.6447C6.36662 17.6559 4.6875 13.6021 4.6875 9.37521C4.68757 8.00666 5.18648 6.68506 6.0908 5.65787C6.99512 4.63068 8.24285 3.96834 9.60035 3.79485C9.80146 3.77052 10.005 3.8122 10.1804 3.91362C10.3558 4.01503 10.4934 4.1707 10.5726 4.35715L12.927 9.85065C12.9879 9.99274 13.0127 10.1477 12.9992 10.3017C12.9857 10.4557 12.9344 10.604 12.8497 10.7333L10.9001 13.7122C10.8114 13.8462 10.7589 14.0009 10.7479 14.1613C10.7368 14.3216 10.7676 14.4821 10.8371 14.627V14.627Z"
                stroke="#22031F"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default PhoneCallIcon;
